module.exports = __webpack_public_path__ + "img/roi_high-profile_procurement.276fe7de.jpg";